<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<div class="container">
  <div class="section-spacing">
    <!-- Gearset Selection -->
    <app-gearset-selection></app-gearset-selection>
  </div>
  <div class="section-spacing">
    <!-- Modslot Visualization -->
    <app-modslot-visualization></app-modslot-visualization>
  </div>
  <div class="section-spacing">
    <!-- Mod Limit Selection -->
    <app-mod-limit-segmented></app-mod-limit-segmented>
  </div>
</div>

<div id="clear-container">
  <button (click)="clear()" color="warn" mat-stroked-button>
    <mat-icon>delete_sweep</mat-icon>
    Clear the whole selection
  </button>
</div>
<div class="minispace"></div>
